import React from "react"
import LoadingSpinner from "./loading-spinner"

function Loading({ message }: { message?: string }): JSX.Element {
  return (
    <div className="flex gap-1">
      <LoadingSpinner />
      <div>{message || `Loading...`}</div>
    </div>
  )
}

export default Loading
